import { useQuery } from "react-query";

import { QUERY_KEYS } from "../../../constants/queryKeys";
import { TradeInApi } from "../../../services";

const getQueryFn = () => {
  try {
    const tradeInApi = new TradeInApi();
    return () => tradeInApi.getTradeInDevices();
  } catch {
    return () => Promise.reject();
  }
};

export const useGetTradeInDevices = (enabled: boolean = true) => {
  return useQuery([QUERY_KEYS.tradeInDevices], {
    queryFn: getQueryFn(),
    enabled,
  });
};
